import { NursingHomeQuickOverview } from './NursingHomeQuickOverview';
import { QuickCreation } from './QuickCreation';
import {
  useEmployeeIsNursingHomeAdminOrManager,
  useIsNursingHomeScope,
} from '@pflegenavi/frontend/nursing-home-context';
import { type FC } from 'react';

export const MenuItems: FC = () => {
  const employeeIsNursingHomeAdminOrManager =
    useEmployeeIsNursingHomeAdminOrManager();

  // Both menus act on the selected nursing home, so at legal entity or tenant
  // scope they would show and change a home the user is not looking at.
  const isNursingHomeScope = useIsNursingHomeScope();

  if (!employeeIsNursingHomeAdminOrManager) {
    return null;
  }

  return (
    <>
      {isNursingHomeScope && (
        <>
          <QuickCreation />
          <NursingHomeQuickOverview />
        </>
      )}
    </>
  );
};
